// src/api.js (PRODUCCIÓN)
// API base fija al backend público (sin depender de variables de entorno)
import axios from 'axios';

const BASE_URL = 'https://api.osmarmexico.com/api';
const TOKEN_KEY = 'api_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) =>
  t ? localStorage.setItem(TOKEN_KEY, String(t).trim()) : localStorage.removeItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
  withCredentials: false, // cambia a true si usas cookies/Sanctum
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Accept-Language': 'es-MX',
  },
});

// ===== Interceptor: REQUEST (adjunta Bearer si existe) =====
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${String(token).trim()}`;
  else delete config.headers.Authorization;
  return config;
});

// ===== Interceptor: RESPONSE (captura y guarda tokens) =====
api.interceptors.response.use(
  (res) => {
    const newToken =
      res?.data?.token ||
      res?.data?.access_token ||
      res?.data?.data?.token ||
      res?.data?.data?.access_token;

    if (newToken) setToken(newToken);
    return res;
  },
  (err) => {
    const s = err?.response?.status;

    // Normaliza el error para tus catch
    err.normalized = {
      status: s ?? 0,
      message:
        err?.response?.data?.message ||
        err?.message ||
        'Error de red. Intenta nuevamente.',
      errors: err?.response?.data?.errors || null,
    };

    // Limpia token en 401 (excepto endpoints de auth)
    if (s === 401) {
      const url = err?.config?.url ?? '';
      const isAuthEndpoint = /login|register|password|forgot|reset/i.test(url);
      if (!isAuthEndpoint) clearToken();
    }
    return Promise.reject(err);
  }
);

export default api;

// Azúcar sintáctico
export const get  = (url, config)      => api.get(url, config).then(r => r.data);
export const post = (url, data, config) => api.post(url, data, config).then(r => r.data);
export const put  = (url, data, config) => api.put(url, data, config).then(r => r.data);
export const del  = (url, config)       => api.delete(url, config).then(r => r.data);

// (Opcional) exporta BASE_URL si lo necesitas en otros lados
export { BASE_URL };
